/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon24Solid = forwardRef('ArrowShapeTriangleAUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.508 5.934 4.133 16.335C3.42 17.501 4.258 19 5.625 19h12.75c1.368 0 2.207-1.499 1.492-2.665l-6.375-10.4a1.75 1.75 0 0 0-2.984 0Z" })));
});
